import { render } from "./ModalSendInvite.vue?vue&type=template&id=f4daef6c&scoped=true"
import script from "./ModalSendInvite.vue?vue&type=script&lang=js"
export * from "./ModalSendInvite.vue?vue&type=script&lang=js"

import "./ModalSendInvite.vue?vue&type=style&index=0&id=f4daef6c&lang=scss&scoped=true"

import exportComponent from "C:\\pirca\\Forge.Ruky\\PircaSolutions.Forge.Ruky.Backoffice.UI\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f4daef6c"]])

export default __exports__